import { useParams } from "react-router-dom"
import { Box, Divider, Grid, InputAdornment, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { formatDateTime, formatTime, formattedDate } from "../../../lib/time"
import { useGetTimeInMaterialReport } from "./hooks"
import { ImageOutlined } from "@mui/icons-material"
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useCallback } from "react"

const fontStyle = {
    color: '#979AAB',
    fontFamily: 'Buenos Aires',
    fontSize: 11,
    lineHeight: '30px',
    fontWeight: '400'
}

const logoBox = {
    height: '50px',
    width: '130px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}

const logo = {
    margin: 'auto',
    fontWeight: 600,
    fontFamily: 'Rza',
    backgroundColor: '#2499EF',
    color: '#fff',
    padding: '10px'
}

const tiltle = {
    fontWeight: 600,
    fontFamily: 'Rza',
    marginBottom: 5,
    fontSize: '48px',
    lineHeight: '63px',
    color: '#2B262C'
}

const title2 = {
    fontWeight: 600,
    fontFamily: 'Rza',
    marginTop: 5,
    fontSize: '40px',
    lineHeight: '52.64px',
    color: '#2B262C'
}

const reportNumber = {
    fontWeight: '300',
    fontSize: '28px',
    lineHeight: '34px',
    fontFamily: 'Buenos Aires'
}

const miniText = {
    fontSize: '12px',
    textTransform: 'none',
    fontWeight: 400,
    color: '#75788F',
    fontFamily: 'Buenos Aires'
}

const subText = {
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '2px',
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: '23px',
    fontFamily: 'Buenos Aires',
    color: '#2B262C'
}

const formField = {
    fontSize: '12px',
    fontWeight: '700',
    fontFamily: 'Buenos Aires',
    lineHeight: '30px'
}

const textFieldd = {
    fontFamily: 'Buenos Aires',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '30px'
}

const date = {
    fontFamily: 'Buenos Aires',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '30px',
    marginRight: '10px'
}
const formStyle2 = {
    marginTop: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '8px'
}
const formStyle = {
    height: '220px',     
    width: '100%',    
    marginTop: '4px', 
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '8px'     
}
interface Timecard {
    startTimeStamp: string;
    firstName: string;
    lastName: string;
    budgetedHours: number;
    regularTimeWorked: number;
    overTimeWorked: number;
    totalTimeWorked: number;
    description: string;
}


export const TimeInMaterialReportExportNew = (props: any) => {
    const { id, reportId } = useParams()
    const { data, isFetching } = useGetTimeInMaterialReport(
        'timematerialreport',
        id
    )

    const images = [
        {
            name: '20230913_142903_photo',
            takenOn: 'Sep 13, 2023, 5:29 PM EDT',
            addedOn: 'Sep 13, 2023, 5:42 PM EDT',
            addedBy: 'erincon erincon',
            description: ''
        },
        {
            name: '20230913_142903_photo',
            takenOn: 'Sep 13, 2023, 5:29 PM EDT',
            addedOn: 'Sep 13, 2023, 5:42 PM EDT',
            addedBy: 'erincon erincon',
            description: ''
        },
        {
            name: '20230913_142903_photo',
            takenOn: 'Sep 13, 2023, 5:29 PM EDT',
            addedOn: 'Sep 13, 2023, 5:42 PM EDT',
            addedBy: 'erincon erincon',
            description: ''
        },
        {
            name: '20230913_142903_photo',
            takenOn: 'Sep 13, 2023, 5:29 PM EDT',
            addedOn: 'Sep 13, 2023, 5:42 PM EDT',
            addedBy: 'erincon erincon',
            description: ''
        }
    ]
    const processTimecards = useCallback(() => {
        return data?.timecards?.map((item: any) => ({
            startTimeStamp: item?.startTimeStamp,
            firstName: item?.user?.firstName,
            lastName: item?.user?.lastName,
            budgetedHours: item?.costCodes?.reduce(
                (totalHours: number, costCode: any) => {
                    return totalHours + (costCode?.costCode?.budgetedHours || 0);
                },
                0
            ),
            regularTimeWorked: item?.formattedTimeDurations?.regularTimeWorked,
            overTimeWorked: item?.formattedTimeDurations?.overTimeWorked,
            totalTimeWorked: item?.formattedTimeDurations?.totalTimeWorked,
        }));
    }, [data]);

    const rows = processTimecards();

    function createData(
        name: string,
        hr: string,
        code: string,
        desc: string,
    ) {
        return { name, hr, code, desc };
    }

    return (
        <>
            {data ? (
                <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
                    {/* --------------------START FIRST SECTION---------------------------------------- */}
                    <Box sx={{
                        height:'5vh',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '20px 0',
                    }}>     
                    </Box> 
                    <Box
                        sx={{ marginTop: 5, marginLeft: 2, marginRight: 2 }}>
                        <Box sx={{
                            color: '#75788F',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'end',
                            marginBottom: 2,
                        }}>
                            <Typography variant='h5' sx={reportNumber} gutterBottom>
                                #{data?.reportNumber}
                            </Typography>
                            <Box sx={logoBox}>
                                <Typography variant="h4" sx={logo}>
                                    Bynaus
                                </Typography>
                            </Box>
                        </Box>
                        <Typography variant='h3' gutterBottom sx={tiltle}>
                            DMS T&M
                        </Typography>
                        <Box sx={{ fontFamily: 'Buenos Aires' ,marginBottom: '850px' }}>
                            <Grid container spacing={0} >
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Created By:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '700',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {data?.project?.clientName}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Location:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '700',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {data?.project?.locations[0].address}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Form Date:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {formattedDate(data.createdAt)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                    <Grid container alignItems={"center"}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Description:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {data?.project?.projectDescription}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Due Date:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {formattedDate(data?.project?.projectDueDate)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} >
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Last Update:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {formattedDate(data?.updatedAt) + ' ' + formatTime(data?.updatedAt)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Status:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145'
                                            }}>
                                            <Box sx={{
                                                width: 'fit-content',
                                                backgroundColor: '#E1FAD9',
                                                color: '#537212',
                                                borderRadius: '16px',
                                                padding: '5px 10px',
                                                textTransform: 'uppercase',
                                                fontWeight: '700',
                                                fontSize: '12px',
                                                lineHeight: '15px'
                                            }}>
                                                In Progress
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} >
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Last Updated By:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {data?.project?.clientName}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formField}>Included References:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: '600',
                                                color: '#1D2145',
                                                lineHeight: '30px'
                                            }}>
                                            {'Assets | Files | Forms | Issues | Photos'}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    {/* --------------------END FIRST SECTION---------------------------------------- */}

                    <Box sx={{ marginTop: 5, marginLeft: 2, marginRight: 2, fontFamily: 'Buenos Aires' }}>
                        <Box
                            sx={{ marginTop: 1 }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'end',  
                            }}>
                                <Box>
                                    <Box sx={logoBox}>
                                        <Typography variant="h4" sx={logo}>
                                            Bynaus
                                        </Typography>
                                    </Box>
                                    <Typography variant='h3' gutterBottom sx={title2}>
                                        Time and Material Ticket
                                    </Typography>
                                </Box>
                                <Box sx={{ color: '#75788F', textTransform: 'capitalize', marginBottom: 10, marginRight: 5 }}>
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, fontFamily: 'Buenos Aires' }}>390 Selby Street, San Francisco, CA 94124</Typography>
                                    <Divider />
                                    <Grid container spacing={1} sx={{ padding: '15px 0px', fontSize: 13, fontWeight: 600 }}>
                                        <Grid item xs={3}>Phone</Grid>
                                        <Grid item xs={9} sx={{ color: '#000' }}>(415)  508-4968</Grid>
                                    </Grid>
                                    <Divider />
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ color: '#75788F', textTransform: 'uppercase', marginBottom: 2, fontFamily: 'Buenos Aires' }}>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: '12px', fontWeight: 700, lineHeight: '30px' }} >
                                <Grid item xs={6}>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={3}>
                                            <Grid container alignItems={'center'}>
                                                <Grid item xs={12} sm={2}>
                                                    No:
                                                </Grid>
                                                <Grid item xs={12} sm={10}>
                                                    <TextField size="small" value={data?.reportNumber} sx={{ maxWidth: '100px' }} variant="outlined" />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Grid container alignItems={'center'}>
                                                <Grid item xs={12} sm={1}>
                                                    Date:
                                                </Grid>
                                                <Grid item xs={12} sm={11}>
                                                    <TextField size="small" value={data?.date} sx={{ width: '100%' }} variant="outlined" />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 13, fontWeight: 600, alignItems: 'center' }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={4} sx={{ color: '#75788F' }}>
                                            General Contractor
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <TextField size="small" value={data?.project?.clientName} fullWidth sx={{ maxWidth: '100%' }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                            Project Name
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <Typography sx={{ overflowWrap: 'anywhere', color: '#000', minHeight: '50px', fontSize: 13, border: '1px solid #D6D6E4', p: '8.5px 14px', borderRadius: '4px' }} >
                                                {data?.project?.projectName}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', alignItems: 'center', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={4} sx={{ color: '#75788F' }}>
                                            Authorized by
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <TextField size="small" value={data?.authorizedBy} fullWidth sx={{ maxWidth: '100%' }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                            Project  No
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <TextField size="small" value={data?.project?.projectNumber} fullWidth sx={{ maxWidth: '100%' }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container alignItems={'center'} sx={{ mb: 3 }}>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={4}></Grid>
                                        <Grid item xs={12} sm={8}>
                                            <Typography sx={miniText}>
                                                * By signing this, you are confirming that you have the authority to initiate the work to be performed
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container alignItems={'center'} justifyContent={'center'} sx={{ backgroundColor: '#FCF1ED', padding: '15px 0px', color: '#000' }}>
                                <Grid item xs={9}>
                                    <Typography sx={subText}>
                                        The General Contractor is requesting the following work to be performed on a time and material basis.
                                    </Typography>
                                    <Typography sx={subText}>
                                        DMS must have written notification and expressed approval to proceed for all work performed outside of contract.
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', alignItems: 'center', fontSize: 13, fontWeight: 600, pb: 0 }} >
                                <Grid item xs={6} sx={{ color: '#75788F' }}>
                                    Description of Work to be performed:
                                </Grid>
                                <Grid xs={1}>
                                </Grid>
                                <Grid item xs={5}>
                                    <Grid container alignItems={'center'} justifyContent={'end'}>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <Typography sx={{ fontFamily: 'Buenos Aires', fontWeight: 700, lineHeight: '30px', color: '#75788F', fontSize: '12px' }}>Change Event #</Typography>
                                            <Typography sx={{
                                                fontFamily: 'Buenos Aires',
                                                fontWeight: 400,
                                                lineHeight: '18px',
                                                color: '#75788F',
                                                textTransform: 'none',
                                                fontSize: '12px'
                                            }}>(ex: ASI # or RFI #)</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={2} md={2}>
                                            <TextField size="small" value={data?.changeEvent} fullWidth sx={{ maxWidth: '100%', textTransform: 'none' }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} sx={{ padding: '10px 0px', alignItems: 'center', fontSize: 14, fontWeight: 600 }} >
                                <Grid item xs={12}>
                                    <Typography sx={{ textTransform: 'none', color: '#1D2145', overflowWrap: 'anywhere', form: 'none', fontFamily: 'Buenos Aires', minHeight: '100px', fontSize: 14, border: '1px solid #D6D6E4', p: '8.5px 14px', borderRadius: '4px' }} >
                                        {data?.descriptionOfWork}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 12, fontFamily: 'Buenos Aires', fontWeight: 700, marginBottom: 2 }} >
                                <Grid item xs={12} sx={{ mb: 1 }}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow sx={{
                                                ' th': {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '8px 10px',
                                                    color: '#75788F',
                                                    textTransform: 'uppercase',
                                                    fontSize: "12px",
                                                    lineHeight: '30px',
                                                    fontFamily: 'Buenos Aires',
                                                }
                                            }}>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Employee Name</TableCell>
                                                <TableCell>Hourly Rate</TableCell>
                                                <TableCell>Regular Hours</TableCell>
                                                <TableCell>Overtime Hours</TableCell>
                                                <TableCell>Total Hours</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rows.map((row: Timecard, index: number) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        " td": {
                                                            border: 1,
                                                            borderColor: "#D6D6E4",
                                                            padding: "5px 10px",
                                                            color: "#1D2145",
                                                            backgroundColor: index % 2 == 0 ? "#F5F5FD" : "",
                                                        },
                                                        height: "25px",
                                                    }}
                                                >
                                                    {" "}
                                                    <TableCell>
                                                        {formattedDate(row.startTimeStamp)}
                                                    </TableCell>
                                                    <TableCell>
                                                        {" "}
                                                        {row.firstName} {row.lastName}
                                                    </TableCell>
                                                    <TableCell>{row.budgetedHours}</TableCell>
                                                    <TableCell>{row.regularTimeWorked}</TableCell>
                                                    <TableCell>{row.overTimeWorked}</TableCell>
                                                    <TableCell>{row.totalTimeWorked}</TableCell>
                                                    <TableCell
                                                        sx={{ backgroundColor: "#FBDACE !important" }}
                                                    >
                                                        {""}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            <TableRow sx={{
                                                ' td':
                                                {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '5px 10px',
                                                    color: '#75788F',
                                                },
                                                height: '25px'
                                            }}>
                                                <TableCell colSpan={3}
                                                    sx={{
                                                        border: 'none !important',
                                                        textAlign: 'end',
                                                        textTransform: 'uppercase',
                                                        fontSize: '12px',
                                                        fontWeight: 700,
                                                        fontFamily: 'Buenos Aires',
                                                        lineHeight: '30px',
                                                    }}>
                                                    Totals</TableCell>
                                                <TableCell sx={{ backgroundColor: '#FBDACE !important' }}></TableCell>
                                                <TableCell sx={{ backgroundColor: '#FBDACE !important' }}></TableCell>
                                                <TableCell sx={{ backgroundColor: '#FBDACE !important' }}></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                                <Grid item xs={12}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow sx={{
                                                ' th': {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '8px 10px',
                                                    color: '#75788F',
                                                    textTransform: 'uppercase',
                                                    fontSize: "12px",
                                                    fontFamily: 'Buenos Aires',
                                                    fontWeight: '700'
                                                }
                                            }}>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Material Description</TableCell>
                                                <TableCell>Qty</TableCell>
                                                <TableCell>Material Price</TableCell>
                                                <TableCell>Total</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.materialsDelivered?.map((m: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td':
                                                        {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            color: '#1D2145',
                                                            backgroundColor: i % 2 == 0 ? '#F5F5FD' : '',
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{''}</TableCell>
                                                    <TableCell>{m.lineItemValue}</TableCell>
                                                    <TableCell>{0}</TableCell>
                                                    <TableCell>{0}</TableCell>
                                                    <TableCell sx={{ backgroundColor: '#FBDACE !important' }}>{0}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableBody>
                                            {data?.materialsDelivered?.map((m: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td':
                                                        {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            color: '#1D2145',
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell sx={{ backgroundColor: '#FBDACE !important' }}>{""}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableBody>
                                            {data?.materialsDelivered?.map((m: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td':
                                                        {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            color: '#1D2145',
                                                            backgroundColor: i % 2 == 0 ? '#F5F5FD' : '',
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell sx={{ backgroundColor: '#FBDACE !important' }}>{""}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Grid>
                                <Grid item xs={12}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow sx={{
                                                ' th': {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '8px 10px',
                                                    color: '#75788F',
                                                    textTransform: 'uppercase',
                                                    fontSize: "12px",
                                                    fontFamily: 'Buenos Aires',
                                                    fontWeight: '700'
                                                }
                                            }}>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Equipment Description</TableCell>
                                                <TableCell>Qty</TableCell>
                                                <TableCell>Daily Rate</TableCell>
                                                <TableCell>Total</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.equipment.map((e: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td':
                                                        {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            color: '#1D2145',
                                                            backgroundColor: i % 2 == 0 ? '#F5F5FD' : '',
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{''}</TableCell>
                                                    <TableCell>{e.lineItemValue}</TableCell>
                                                    <TableCell>{0}</TableCell>
                                                    <TableCell>{0}</TableCell>
                                                    <TableCell sx={{ backgroundColor: '#FBDACE !important' }}>{0}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableBody>
                                            {data?.equipment.map((e: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td':
                                                        {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell sx={{ backgroundColor: '#FBDACE !important' }}>{""}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableBody>
                                            {data?.equipment.map((e: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td':
                                                        {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            color: '#1D2145',
                                                            backgroundColor: i % 2 == 0 ? '#F5F5FD' : '',
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell>{""}</TableCell>
                                                    <TableCell sx={{ backgroundColor: '#FBDACE !important' }}>{""}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Box>

                        <Grid container alignItems={'center'} justifyContent={'center'} sx={{ backgroundColor: '#FCF1ED', padding: '15px 0px', color: '#000', mb: 2, mt:'200px' }}>
                            <Grid item xs={9}>
                                <Typography sx={subText}>
                                    Contractor agrees by signing this form that they have the authority to request and order work to be performed and have verified <br /> the time andmaterials that have been performed on the project.
                                </Typography>
                                <Typography sx={subText}>
                                    Payment for time and material will be paid within 30 days of invoicing of the tickets.
                                </Typography>
                            </Grid>
                        </Grid>

                        <Box sx={{ color: '#75788F', textTransform: 'uppercase', marginBottom: 3 }}>
                            <Grid container spacing={2} sx={{ justifyContent: 'space-between', padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'} sx={{ color: '#75788F' }}>
                                        <Grid item xs={12} sm={4} sx={textFieldd}>
                                            DMS Employee Signature
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" value={data?.employeeSignature} fullWidth sx={{ maxWidth: '100%' }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'} justifyContent={'end'} sx={{ color: '#75788F' }}>
                                        <Grid item xs={12} sm={1} sx={date}>
                                            Date
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" value={''} fullWidth sx={{ maxWidth: '100%' }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ justifyContent: 'space-between', padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'} sx={{ color: '#75788F' }}>
                                        <Grid item xs={12} sm={4} sx={textFieldd}>
                                            Contractor Signature
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" value={data?.clientSignature} fullWidth variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'} justifyContent={'end'} sx={{ color: '#75788F' }}>
                                        <Grid item xs={12} sm={1} sx={date}>
                                            Date
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" fullWidth variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ justifyContent: 'space-between', padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'} sx={{ color: '#75788F' }}>
                                        <Grid item xs={12} sm={4} sx={textFieldd}>
                                            I.O.R. Signature
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" value={data?.iorSignature} fullWidth variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'} justifyContent={'end'} sx={{ color: '#75788F' }} >
                                        <Grid item xs={12} sm={1} sx={date}>
                                            Date
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" fullWidth variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Box sx={formStyle}
                                >
                                </Box>
                           </Grid>
                        </Box>

                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px 0',
                                    marginTop:'750px'
                                }}>
                            </Box>
                            <Typography variant='h3' gutterBottom sx={{ fontWeight: 600, fontFamily: 'Rza', marginBottom: 2}}>
                                References
                            </Typography>
                            <Typography variant='h5' gutterBottom
                                sx={{
                                    fontWeight: 600,
                                    fontFamily: 'Rza',
                                    marginBottom: 0,
                                    backgroundColor: '#F5F5FD',
                                    p: 2,
                                }}>
                                Photos(11)
                            </Typography>
                            <Grid container spacing={2} pt={2}>
                                {images?.map((img: any, i: number) => {
                                    return (
                                        <Grid key={i} item xs={3}>
                                            <Box sx={{
                                                backgroundColor: '#D9D9D9',
                                                height: '500px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 2
                                            }}>
                                                <ImageOutlined sx={{ height: '100px', width: '100px', color: '#00000021' }} />
                                            </Box>
                                            <Typography sx={{
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                color: '#2B262C',
                                                marginBottom: 1
                                            }}>
                                                {img?.name}
                                            </Typography>
                                            <Typography sx={{
                                                color: '#75788F',
                                                fontSize: '15px',
                                                fontFamily: 'Buenos Aires',
                                                py: 1
                                            }}>
                                                {img?.description}
                                            </Typography>
                                            <Divider />
                                            <Box sx={{
                                                display: 'flex',
                                                color: '#75788F',
                                                justifyContent: 'space-between',
                                                py: 1
                                            }}>
                                                <Typography sx={{
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                    color: '#75788F',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <AccessTimeIcon sx={{ verticalAlign: 'middle', width: '17px', height: '17px', mr: 1 }} />
                                                    {formatDateTime(Date())}
                                                </Typography>
                                            </Box>
                                            <Divider />
                                        </Grid>
                                    )
                                })

                                }
                            </Grid>
                        </Box>
                    </Box>
                </Box >
            ) : null}
        </>
    )
}